//@ts-nocheck
//@ts-ignore
import { useEffect, useState } from 'react';
import { images } from '../constants/images';

export const useProgressiveImageLoad = (currentPage, userFlow) => {
  const [loadedImages, setLoadedImages] = useState(new Set());

  useEffect(() => {
    const getImagesForPage = (page) => {
      const pageImages = {
        'choose-breakfast': [
          images.breakfast9,
          images.breakfast6,
          images.breakfast4,
          images.breakfast7,
          images.breakfast10,
          images.breakfast12,
        ],
        'choose-lunch': [
          images.lunch43,
          images.lunch45,
          images.lunch50,
          images.lunch51,
          images.lunch54,
          images.lunch57,
        ],
        'choose-dinner': [
          images.dinner64,
          images.dinner73,
          images.dinner76,
          images.dinner80,
          images.dinner83,
          images.dinner81,
        ],
        'choose-snack': [
          images.snack24,
          images.snack25,
          images.snack27,
          images.snack37,
          images.snack36,
          images.snack35,
        ],
        'personal-plan-2': Object.values(images),
        'calorie-free': [images.calorieFree],
        'metabolism-type': [
          images.metabolismType,
          images.self,
          images.bodySpeaks,
          images.motivHeart,
        ],
        'metabolism-type-2': [images.metabolismType2],
        'personal-plan-dynamic': [
          images.dnaReviewDaniel,
          images.dnaReviewMaria,
          images.dnaReviewSophie,
          images.metabolism,
          images.dna,
          images.yogurt, images.pizza, images.toast, images.tortilla,
          images.dietImg, images.vineImg
        ],
        'metabolism-impact': [images.metabolismImpact],
        'progress-unlocked': [images.progressUnlocked],
        'elite-insight-access': [images.elite],
        'upsale-nutrition-bundle': [images.upsaleBundle],
        'upsale-dynamic': [images.upsaleBundle, images.upsaleEthnicity, images.upsaleDna],
        'ethnicity-nutrition-promise': [images.ethnicityNutrition],
        'face-scan-animation': [images.faceScanAnimationPoster],
        'dna-map': [images.dnaMap],
        'dna-face': [images.dnaFace],
        // 'self-awareness-start': [images.self],
        // 'body-speaks': [images.bodySpeaks],
        // 'motivation-heart': [images.motivHeart]
      };
      return pageImages[page] || [];
    };

    const currentPageImages = getImagesForPage(currentPage);
    currentPageImages.forEach((src) => {
      if (!loadedImages.has(src)) {
        const img = new Image();
        img.src = src;
        img.onload = () => setLoadedImages((prev) => new Set([...prev, src]));
      }
    });

    const currentIndex = userFlow.indexOf(currentPage);
    const nextPages = userFlow.slice(currentIndex + 1, currentIndex + 3);

    nextPages.forEach((page) => {
      const nextPageImages = getImagesForPage(page);
      setTimeout(() => {
        nextPageImages.forEach((src) => {
          if (!loadedImages.has(src)) {
            const img = new Image();
            img.src = src;
          }
        });
      }, 1000);
    });
  }, [currentPage, userFlow, loadedImages]);

  return loadedImages;
};
